import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';
import useRegisterForm from 'hooks/service/useRegisterForm';
import { buttonStyle, inputStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import styled from 'styled-components';
import NotiModal from 'components/service/NotiModal';
import { CheckBox, CheckBoxSelected } from 'lib/styles/icons';
import { useState } from 'react';
import UserAgreementModal from './UserAgreementModal';

const RegisterForm = () => {
  const [isCheckBoxSelected, setIsCheckBoxSelected] = useState([false, false]);
  const [showUserAgreementModal, setShowUserAgreementModal] = useState(false);

  const {
    linkData,
    password,
    passwordConfirm,
    tel,
    serverAuthCode,
    localAuthCode,
    auth,
    isNotRegistered,
    localErrors,
    passwordErrors,
    showNotiModal,
    showFailModal,
    onChange,
    onCheck,
    onSend,
    onCertificate,
    onRegister,
    setShowFailModal,
  } = useRegisterForm();

  if (linkData.isLoading) return <Loading />;
  if (linkData.isError)
    return <ErrorNoti errorMsg={linkData.error.response.data.msg} />;

  const {
    data: { data },
  } = linkData;

  const onAgree = idx => {
    setIsCheckBoxSelected(prev => {
      const next = [...prev];
      next[idx] = !next[idx];
      return next;
    });
  };

  return (
    <>
      {showFailModal && (
        <NotiModal fail closeModal={() => setShowFailModal(false)} />
      )}
      {showNotiModal && <NotiModal />}
      {showUserAgreementModal && (
        <UserAgreementModal onClose={() => setShowUserAgreementModal(false)} />
      )}
      <RegisterFormBlock>
        <div className="box">
          <div className="title">SK Shieldus 회원가입</div>
          <div className="index">이름</div>
          <StyledInput type="text" disabled value={data.name} />
          <div className="index">아이디(이메일)</div>
          <div className="row">
            <StyledInput type="text" name="email" value={data.email} disabled />
            <StyledButton onClick={onCheck}>조회</StyledButton>
          </div>
          <div className="check-msg">
            {isNotRegistered &&
              isNotRegistered !== null &&
              '가입이 필요한 사용자입니다'}
            {!isNotRegistered &&
              isNotRegistered !== null &&
              '가입 정보가 있는 사용자입니다'}
          </div>
          <div className="check-msg fail">
            {localErrors.isCheckId && localErrors.isCheckId}
          </div>
          {isNotRegistered && (
            <>
              <div className="index">비밀번호</div>
              <div className="row">
                <StyledInput
                  type="password"
                  name="password"
                  value={password}
                  onChange={onChange}
                />
                <div className="msg">
                  영문, 숫자를 조합하여 8자리 이상 기입해 주세요
                </div>
              </div>
              {passwordErrors.password && (
                <div className="check-msg fail">{passwordErrors.password}</div>
              )}
              <div className="index">비밀번호 재입력</div>
              <div className="row">
                <StyledInput
                  type="password"
                  name="passwordConfirm"
                  value={passwordConfirm}
                  onChange={onChange}
                />
              </div>
              {passwordErrors.passwordConfirm && (
                <div className="check-msg fail">
                  {passwordErrors.passwordConfirm}
                </div>
              )}
            </>
          )}
          <div className="index">핸드폰</div>
          <div className="row">
            <StyledInput
              type="text"
              placeholder="숫자만 입력해주세요"
              name="tel"
              value={tel}
              onChange={onChange}
            />
            <StyledButton style={{ width: 150 }} onClick={onSend}>
              인증 번호 전송
            </StyledButton>
          </div>
          {localErrors.msgSendError && (
            <div className="check-msg fail">{localErrors.msgSendError}</div>
          )}
          {serverAuthCode && (
            <div className="check-msg">문자가 전송되었습니다</div>
          )}
          {serverAuthCode && (
            <>
              <div className="index">인증번호</div>
              <div className="row">
                <StyledInput
                  type="text"
                  name="localAuthCode"
                  value={localAuthCode}
                  onChange={onChange}
                />
                <StyledButton onClick={onCertificate}>확인</StyledButton>
              </div>
              {auth && (
                <div className="check-msg">본인인증이 확인되었습니다</div>
              )}
              {!auth && auth !== null && (
                <div className="check-msg fail">인증번호가 틀렸습니다</div>
              )}
            </>
          )}
          <div className="index">매장 정보</div>
          <div className="row">
            <StyledInput type="text" disabled value={data['store.name']} />
          </div>
          <div className="index">직급</div>
          <div className="row">
            <StyledInput
              type="text"
              disabled
              value={data.level === '2' ? '시니어 관리자' : '주니어 관리자'}
            />
          </div>
          <div className="agreement-block">
            <div className="agreement-wrapper">
              {isCheckBoxSelected[0] ? (
                <CheckBoxSelected
                  className="check-box"
                  onClick={() => onAgree(0)}
                />
              ) : (
                <CheckBox className="check-box" onClick={() => onAgree(0)} />
              )}
              <div onClick={() => setShowUserAgreementModal(true)}>
                이용약관
              </div>
            </div>
            <div className="agreement-wrapper">
              {isCheckBoxSelected[1] ? (
                <CheckBoxSelected
                  className="check-box"
                  onClick={() => onAgree(1)}
                />
              ) : (
                <CheckBox className="check-box" onClick={() => onAgree(1)} />
              )}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.skshieldus.com/kor/policy/adtcaps.do"
              >
                개인정보처리방침
              </a>
            </div>
          </div>
          <div className="register-btn-wrapper">
            <StyledButton
              onClick={onRegister}
              disabled={
                !auth || !isCheckBoxSelected[0] || !isCheckBoxSelected[1]
              }
            >
              가입하기
            </StyledButton>
          </div>
        </div>
      </RegisterFormBlock>
    </>
  );
};

export default RegisterForm;

const RegisterFormBlock = styled.div`
  height: 100%;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${palette.gray[0]};
  overflow-y: auto;

  .box {
    width: 480px;
    margin: 0 auto;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    margin-top: 2rem;
    font-size: 1.3rem;
    font-weight: bold;
    letter-spacing: 4px;
    text-align: center;
  }

  .index {
    font-weight: bold;
    margin-top: 1.5rem;
  }

  .msg {
    margin-top: 6px;
    margin-left: 10px;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    font-style: italic;
  }

  .check-msg {
    margin-top: 6px;
    margin-left: 10px;
    font-size: 11px;
    font-style: italic;
    color: ${palette.theme[3]};
  }

  .fail {
    color: red;
  }

  input[type='password'] {
    width: 50%;
  }

  .register-btn-wrapper {
    display: flex;
    justify-content: center;
    button {
      margin: 0;
      width: 120px;
      margin-top: 2.5rem;
      padding: 10px 20px;
      font-size: 16px;
    }
    button:disabled {
      background: ${palette.gray[5]};
    }
  }

  .agreement-block {
    margin-top: 2rem;
    display: flex;
    font-size: 15px;
  }

  .agreement-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: underline;
    user-select: none;
    cursor: pointer;
    &:hover,
    a:hover {
      color: ${palette.theme[3]};
    }
  }

  .check-box {
    margin-right: 10px;
    font-size: 20px;
  }
`;

const StyledInput = styled.input`
  ${inputStyle}
  width: 100%;
  &:disabled {
    background: ${palette.gray[3]};
  }
`;

const StyledButton = styled.button`
  ${buttonStyle}
  width: 80px;
  margin-top: 6px;
  margin-left: 20px;
  padding: 5px 6px;
`;
